// Environment
export const ENV_PRODUCTION = process.env.REACT_APP_NODE_ENV === "production" || process.env.NODE_ENV === "production";

// API Configuration
export const API_URL = process.env.REACT_APP_API_URL;
export const API_URL_GRAPHQL = `${process.env.REACT_APP_API_URL}/graphql`;

// Site URLs
export const ONBOARDING_SITE_URL = process.env.REACT_APP_ONBOARDING_SITE_URL;
export const DASHBOARD_SITE_URL = process.env.REACT_APP_DASHBOARD_SITE_URL;

// Sentry configuration
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT;
export const SENTRY_SEND_DEFAULT_PII = process.env.REACT_APP_SENTRY_SEND_DEFAULT_PII === 'true';
export const SENTRY_TRACES_SAMPLE_RATE = parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '1.0');
export const SENTRY_DEBUG = process.env.REACT_APP_SENTRY_DEBUG === 'true';

